/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DSAReportDecisionLegality = "ILLEGAL" | "LEGAL" | "%future added value";
export type NOTIFICATION_TYPE = "COMMENT_APPROVED" | "COMMENT_FEATURED" | "COMMENT_REJECTED" | "DSA_REPORT_DECISION_MADE" | "ILLEGAL_REJECTED" | "PREVIOUSLY_REJECTED_COMMENT_APPROVED" | "REPLY" | "REPLY_STAFF" | "UNKNOWN" | "%future added value";
export type DSAReportDecisionMadeNotificationBody_notification = {
    readonly type: NOTIFICATION_TYPE | null;
    readonly comment: {
        readonly author: {
            readonly username: string | null;
        } | null;
    } | null;
    readonly dsaReport: {
        readonly createdAt: string;
    } | null;
    readonly decisionDetails: {
        readonly legality: DSAReportDecisionLegality | null;
    } | null;
    readonly " $refType": "DSAReportDecisionMadeNotificationBody_notification";
};
export type DSAReportDecisionMadeNotificationBody_notification$data = DSAReportDecisionMadeNotificationBody_notification;
export type DSAReportDecisionMadeNotificationBody_notification$key = {
    readonly " $data"?: DSAReportDecisionMadeNotificationBody_notification$data;
    readonly " $fragmentRefs": FragmentRefs<"DSAReportDecisionMadeNotificationBody_notification">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DSAReportDecisionMadeNotificationBody_notification",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "comment",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "username",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "NotificationDSAReportDetails",
            "kind": "LinkedField",
            "name": "dsaReport",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "NotificationDecisionDetails",
            "kind": "LinkedField",
            "name": "decisionDetails",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "legality",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Notification",
    "abstractKey": null
} as any);
(node as any).hash = 'f9bd1712e86d32fb342968eeb481efa4';
export default node;
